<h6 class="details__heading">{{'ONBOARDING.USE_CASE_LEVELS.LEVEL_OF_DETAIL' | translate}}:</h6>
<p class="details__text">{{'ONBOARDING.USE_CASE_LEVELS.LEVEL_OF_DETAIL_DESCRIPTION' | translate}}</p>
<div class="details__list">
    <ng-container *ngFor="let useCaseConsentChapter of useCaseDetails?.chapterUnits">
        <h5 class="details__list__title">{{useCaseConsentChapter.unitTitle | chapterTranslation}}</h5>
        <span class="details__list__slider">
            <app-slider
                    [tabindex]="1"
                    [ariaLabel]="useCaseConsentChapter.unitTitle | chapterTranslation"
                    [itemId]="useCaseConsentChapter.unitId"
                    [values]="consentUseCaseValues"
                    [selected]="useCaseConsentChapter.unitLevel | levelToIntensity"
                    [showLabel]=true
                    (sliderChangedEvent)="sliderChangeEvent.emit($event)">
            </app-slider>
        </span>
    </ng-container>
</div>
<div class="details__text">
    <h6 class="details__heading">{{'GENERAL.ESTIMATED_TIME' | translate}}</h6>
    <p class="details__text">{{'ONBOARDING.USE_CASE_LEVELS.DURATION_DESCRIPTION_READ' | translate}}</p>
</div>
<div class="details__list duration">
    <h5 class="details__list__title">{{'GENERAL.DURATION' | translate }}</h5>
    <span class="details__list__slider">
        <app-slider
                [cssClasses]="'duration'"
                [tabindex]="1"
                [ariaLabel]="'GENERAL.ESTIMATED_TIME' | translate"
                [values]="provisionDurationValues"
                [selected]="provisionDuration"
                [showLabel]=true
                [durationSlider]=true
                [defaultValue]="defaultLevel | durationTranslation"
                (sliderChangedEvent)="relevanceChangeEvent.emit($event)">
        </app-slider>
    </span>
    <div class="details__list__estimated-time">
        <mat-icon class="material-icons-round details__list__estimated-time__icon">timer</mat-icon>
        <span class="details__list__estimated-time__title">{{getMinutes(durationInMillis)}} {{'GENERAL.MINUTES' | translate }}</span>
    </div>
</div>
<p class="details__text">{{'ONBOARDING.USE_CASE_LEVELS.LEVEL_OF_DETAIL_TEXT' | translate}}</p>
